import { useGetClockDriftQuery } from '../../services/users/operations.enhanced';

/**
 * The user's clock might have drifted a few minutes from standard wall clock time.
 * This happens if the user's PC is not configured to sync with network time servers.
 * It causes weird bugs like 'patient waiting for -30 seconds'.
 *
 * Our solution is to query our server once for the current time,
 * and save the drift in our Redux store (RTK Query cache).
 *
 * We currently do not factor the network request duration,
 * so the accuracy is likely to be within a few seconds, which is acceptable.
 *
 * @returns drift in milliseconds between user's time and our server's time.
 */
export const useClockDrift = (): number => {
  const { data: clockDrift } = useGetClockDriftQuery();

  return clockDrift ?? 0;
};
